(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('quantity-control')){customElements.define('quantity-control',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-quantity-change]');if(!button)return;const input=this.querySelector('input');if(button.dataset.quantityChange==='1')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));});}});}
  } catch(e) { console.error(e); }
})();

})();
